import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import PwaInstallPrompt from "./components/PwaInstallPrompt";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <>
      <App />
      <PwaInstallPrompt />
    </>
  </React.StrictMode>,
);
